package com.essntl.features.message.ui.all_conversation.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.message.domain.model.WhapiChatModel
import com.essntl.features.message.ui.all_conversation.AllConversationEvent
import com.essntl.features.message.ui.all_conversation.AllConversationState
import com.essntl.uikit.components.button.secondary.EsMediumSecondaryButton
import com.essntl.uikit.components.chat.conversation.ConversationFilterOptions
import com.essntl.uikit.components.chat.conversation.overviewcard.ConversationOverviewUiState
import com.essntl.uikit.components.chat.conversation.overviewcard.EsConversationOverviewCard
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ConversationList(
    state: AllConversationState,
    onEvent: (AllConversationEvent) -> Unit,
    filteredConversations: List<WhapiChatModel>,
    selectedConversationId: String?,
    onFilterOptionsChange: (ConversationFilterOptions) -> Unit,
    onConversationClicked: (String, ConversationOverviewUiState.ChatType) -> Unit,
    loadNextPage: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val uiState = remember(
        filteredConversations,
        state.filterOptions,
        state.getAllClient,
    ) {
        state.toUiState(filteredConversations)
    }

    var showSortOptions by remember {
        mutableStateOf(false)
    }

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.ListRowVerticalPadding,
                horizontal = EsConstants.ListRowHorizontalPadding,
            ),
    ) {
//        Row(
//            horizontalArrangement = Arrangement.SpaceBetween,
//            modifier = Modifier.fillMaxWidth(),
//        ) {
//            EsInput(
//                value = uiState.filterOptions.searchText,
//                onValueChange = {
//                    onFilterOptionsChange(
//                        uiState.filterOptions.copy(
//                            searchText = it,
//                        ),
//                    )
//                },
//                placeholder = "Search",
//                prefix = {
//                    EsLargeIcon(
//                        res = EsIcons.Search,
//                    )
//                },
//                minHeight = 48.dp,
//                singleLine = true,
//                modifier = Modifier.weight(1F),
//                shape = RoundedCornerShape(50.dp),
//            )
//            if (currentPlatform == Platform.Desktop) {
//                Spacer(modifier = Modifier.width(12.dp))
//                EsLargeRoundIconButton(
//                    iconRes = EsIcons.Arrange,
//                    onClick = {
//                        showSortOptions = !showSortOptions
//                    },
//                )
//            }
//        }

//        if (currentPlatform == Platform.Desktop)
//            EsConversationSortUI(
//                uiState = uiState,
//                showSortOptions = showSortOptions,
//                onFilterOptionsChange = onFilterOptionsChange,
//                modifier = Modifier.fillMaxWidth(),
//            )

//        Spacer(modifier = Modifier.height(8.dp))
//
//        EsConversationFilterUI(
//            uiState = uiState,
//            onFilterOptionsChange = onFilterOptionsChange,
//            modifier = Modifier.fillMaxWidth(),
//        )
//        Spacer(modifier = Modifier.height(16.dp))

        if (state.isFailure)
            EsMediumSecondaryButton(
                onClick = {
                    onEvent(AllConversationEvent.GetAllWhapiChats)
                },
                text = "An error occurred. Retry",
                enabled = true,
            )
        else
            LazyColumn(
                state = rememberLazyListState(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(12.dp),
            ) {
                itemsIndexed(uiState.conversations) { index, conversation ->
                    EsConversationOverviewCard(
                        uiState = conversation,
                        isSelected = selectedConversationId == conversation.conversationId,
                        onClick = onConversationClicked,
                    )

                    if (index >= uiState.conversations.lastIndex && !state.getAllWhapiChats.isLastPage)
                        loadNextPage()
                }
            }
    }
}